import { string, addMethod, StringSchema, DateValidationMessage } from 'yup';
import { getFormattedDate } from '@itm/shared-frontend/lib/components';
import { getNextDayISO, getPrevDayISO } from '@itm/shared-frontend/lib/utils';

addMethod<StringSchema>(string, 'maxLines', function (maxLines: number) {
  return this.test(
    'maxLines',
    ({ label }) => `max ${maxLines} ${label} is allowed`,
    (value?: string) => {
      if (!value) return true;
      return value.trim().split(/[\s\b]+/g).length <= maxLines;
    },
  );
});

addMethod<StringSchema>(string, 'dateFrom', function (dateToKey: string = 'dateTo', message?: DateValidationMessage) {
  return this.when(dateToKey, ([dateTo]: (string | undefined)[], scheme) =>
    dateTo
      ? scheme.test(
          'dateFromTest',
          (params) =>
            message
              ? typeof message === 'string'
                ? message
                : message(params, dateTo)
              : `${params.label} field must be earlier than ${getFormattedDate(getNextDayISO(dateTo))}`,
          (dateFrom) => (dateFrom ? new Date(dateFrom) < new Date(getNextDayISO(dateTo)) : true),
        )
      : scheme,
  );
});

addMethod<StringSchema>(string, 'dateTo', function (dateFromKey: string = 'dateFrom', message?: DateValidationMessage) {
  return this.when(dateFromKey, ([dateFrom]: (string | undefined)[], scheme) =>
    dateFrom
      ? scheme.test(
          'dateToTest',
          (params) =>
            message
              ? typeof message === 'string'
                ? message
                : message(params, dateFrom)
              : `${params.label} field must be later than ${getFormattedDate(getPrevDayISO(dateFrom))}`,
          (dateTo) => (dateTo ? new Date(getNextDayISO(dateTo)) > new Date(dateFrom) : true),
        )
      : scheme,
  );
});
